import { allpeepNoPayloadEndpoint, allpeepPayloadEndpoint } from './helpers.js';
export const auth = (rawClient) => ({
    login: allpeepPayloadEndpoint(rawClient, '/auth/login'),
    register: allpeepPayloadEndpoint(rawClient, '/auth/register'),
    requestResetPassword: allpeepPayloadEndpoint(rawClient, '/auth/request-reset-password'),
    resetPassword: allpeepPayloadEndpoint(rawClient, '/auth/reset-password'),
    guestPass: allpeepPayloadEndpoint(rawClient, '/auth/guest-pass'),
    refresh: allpeepPayloadEndpoint(rawClient, '/auth/refresh'),
    validateEmail: allpeepNoPayloadEndpoint(rawClient, '/auth/validate-email'),
});
